import EfBundlesCard from '@elem/ui/ef-bundles-card';
import EfSpec from '@elem/ui/ef-spec';
import { Navigation } from 'swiper';
import EfModal from '@elem/ui/ef-modal';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { dataLocal } from './configs';
import styles from './index.module.scss';
import WinA from './WinA';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useLang } from '@/i18n';

export default function Bundles({ callbackCart }: any) {
    const { t } = useLang('dp3.landing.Bundles');
    const { locale } = useRouter();
    const { data } = dataLocal[locale];
    const [gap, setGap] = useState(24);
    const [cards, setCards] = useState(data);
    const [init, setInit] = useState(false);
    const [isOpen, setIsOpen] = useState(false); //是否打开弹窗
    const [winItem, setWinItem] = useState({});
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const [buyHref, setBuyHref] = useState('https://de.ecoflow.com/checkouts/cn/Z2NwLWV1cm9wZS13ZXN0NDowMUo2OVRKMkYzSEJITlo1RjdBUE1DR1EyQw?channel=buy_button');
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1440 ? 24 : window.innerWidth <= 1024 ? 12 : 16);
        }

        const tempData = JSON.parse(JSON.stringify(cards));
        const getAsynItem = async (productId: string, variantId: string, k: number, m = -1) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        const item = m >= 0 ? tempData[k].subs[m] : tempData[k];
                        item.discountPrice = res?.data?.price || 234560;
                        item.originalPrice = res?.data?.compareAtPrice ?? (res?.data?.price || 321000);
                        item.inventoryQuantity = res?.data?.inventoryQuantity || 100;
                        if (m >= 0) {
                            item.parentVarientId = tempData[k].variantId;
                        }
                        // item.inventoryQuantity = 1;
                        // item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                        // 只有子项需要应用接口图片
                        if (res?.data?.img && !item?.img && m >= 0) {
                            item.img = res?.data?.img;
                        }
                        // if (res?.data?.productTitle || res?.data?.skuTitle) {
                        //     item.name = res?.data?.productTitle || res?.data?.skuTitle;
                        // }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        // const promises = tempData?.map((item: EfBundlesCardProps) => getAsynItem(item, ''));
        const promises = [];
        tempData?.map((item: any, k: number) => {
            if (item?.variantId) {
                promises.push(getAsynItem(item?.productId, item?.variantId, k));
                if (item?.subs?.length > 0) {
                    item?.subs?.map((sub: any, m: number) => promises.push(getAsynItem(sub?.productId, sub?.variantId, k, m)));
                }
            }
        });
        Promise.all(promises)
            .then(() => {
                setCards(tempData);
                setInit(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    // 打开免税弹窗
    const callbackBuyHandle = (item: any, buyHref: string) => {
        if (item.isBuyInCallback) {
            setIsOpen(true);
            setWinItem(item);
            setBuyHref(buyHref);
        }
    };
    // 打开免税弹窗
    const closeBuyHandle = () => {
        setIsOpen(false);
    };

    return (
        <div className={styles.bundles} id="eu-bundles-id">
            <EfSpec className="spec-x" />
            <div className="info">
                <p className="title">{t('title')}</p>
                {/* <p className="desc">{t('desc')}</p>
                <p className="tip">
                    {t.rich('tip', {
                        text1: (text: string) => (
                            <a className="text-aa1" href="#footer-tc-id">
                                {text}
                            </a>
                        ),
                    })}
                </p> */}
            </div>
            {init && (
                <Swiper
                    className="swiper-cards"
                    modules={[Navigation]}
                    spaceBetween={gap}
                    loop={false}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    navigation={IS_EU_SITES}
                    autoplay={false}
                    // key={init}
                >
                    {cards?.map((card: EfSwiperItemProps, k: number) => (
                        <SwiperSlide className="swiper-card" key={k}>
                            <EfBundlesCard
                                {...card}
                                alsoLikeText={t('need')}
                                buyLinkCallback={callbackBuyHandle}
                                affirmIconUrl={locale === 'de' ? 'https://websiteoss.ecoflow.com/upload/image/1724919252673/pc-klarna-icon.png' : undefined}
                                hasAffirm={locale === 'de'}
                                gtm_learn_more={{
                                    event: 'uaEvent',
                                    event_name: 'buy',
                                    product_name: card.name,
                                    position: `DP3 Product Sale`,
                                }}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
            <div className="customize">
                <div className="cus-info">
                    <p className="cus-title">{t('customized')}</p>
                    <EfLink
                        className="cus-desc"
                        href={`https://${locale}.ecoflow.com/products/delta-pro-3-portable-power-station`}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: t('customized'),
                            position: `DP3 Product Sale`,
                        }}
                    >
                        {t('choose')} &gt;
                    </EfLink>
                </div>
                <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1724294330635/bl_ps_400w%20rsp_2%2Bdp3_EU%201%20(1).png" />
            </div>
            <EfSpec className="spec-x" />
            {isOpen && (
                <EfModal open={isOpen} className={styles.WinADialog} callback={closeBuyHandle} title="Die Voraussetzungen für 0 % MwSt. Lieferung">
                    <WinA item={winItem} buyHref={buyHref} callback={closeBuyHandle} />
                </EfModal>
            )}
        </div>
    );
}
